<script lang="ts">
	//UI
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	import SaveIcon from "@hitit/hub/src/assets/Icons/Save.png";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	//Types
	//Props
	export let editmode = false;
	export let actionHandler = () => {};
	export let _static = false;
	export let doneText = $t("global.done");
	export let updateText = $t("global.edit");
	//Constants
	//Variables
	//Functions
	//Do
</script>

<div class="action" on:click={actionHandler} class:static={_static}>
	<span>{editmode ? doneText : updateText}</span>
	<img src={editmode ? SaveIcon : EditIcon} alt={editmode ? "save" : "edit"} />
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.action {
		display: flex;
		gap: 10px;
		align-items: center;
		position: absolute;
		right: 10px;
		top: 10px;
		color: #6d6f76;
		font-weight: 500;
		cursor: pointer;
		z-index: 1;

		&.static {
			position: static;
		}

		&:hover {
			cursor: pointer;
		}
		img {
			width: 24px;
			height: 24px;
			object-fit: contain;
		}
	}

	@include DesktopSize {
		.action {
			right: 20px;
			top: 20px;
			font-size: 1.25rem;
		}
	}
</style>
